import api from './api';

export const basketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitOrder: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/submitOrder',
        body,
      })
    }),
    updateBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/UpdateBasket',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    removeFromBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/RemoveFromBasket',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    addToBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/AddToBasket',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    setBasketItems: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url:'basket/SetBasketItems/',
        body
      }),
      invalidatesTags: ['basket']
    }),
    quickAddItemAndReward: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `basket/QuickAddItemAndReward/${body.productId}/${body.portionTypeId}/${body.thirdPartyRewardTypeId}`,
        body,
      }),
      invalidatesTags: ['basket']
    }),    
    quickRemoveItem: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `basket/QuickRemoveItem/${body.productId}/${body.portionId}`,
        body: {},
      }),
      invalidatesTags: ['basket']
    }),
    quickAddItem: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `basket/QuickAddItem/${body.productId}/${body.portionId}`,
        body: {},
      }),
      invalidatesTags: ['basket']
    }),
    checkOutOfStock: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/CheckOutOfStock/',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    addBundleToBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/AddBundleToBasket',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    removeBundleFromBasket: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/removeBundleFromBasket',
        body,
      }),
      invalidatesTags: ['basket']
    }),
    removeOutOfStockItemsFromBasket: builder.mutation({
      query: () => ({
        method: 'POST',
        url: 'basket/RemoveOutOfStockItemsFromBasket',
        body: {},
      }),
      invalidatesTags: ['basket']
    }),
    addVoucher: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/AddVoucher',
        body,
      }),
    }),
    removeVoucher: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: 'basket/RemoveVoucher',
        body,
      }),
    }),
    updateBasketDelivery: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `basket/UpdateBasketDelivery/${body.searchTerm}/${body.restaurantId}`,
        body,
      }),
      invalidatesTags: ['basket']
    }),
    clearBasket: builder.mutation({
      query: () => ({
        method: 'POST',
        url: 'basket/ClearBasket',
      }),
    }),
    clearBasketDelivery: builder.mutation({
      query: () => ({
        method: 'POST',
        url: 'basket/ClearBasketDelivery'
      }),
    }),
    quickSelectItem: builder.mutation({
      query: (body) => ({
        method: 'POST',
        url: `basket/QuickSelectItem/${body.productId}/${body.portionTypeId}/306`,
        body,
      }),
    }),
    setRestaurantDistance:  builder.mutation({
      query: ({id, distance, searchTerm}) => ({
        method: 'POST',
        url: `basket/SetRestaurantDistance/${id}/${distance}/${searchTerm}`,
      }),
    }),
    getUpsellItems: builder.query({
      query: ({ id, type }) => `basket/GetUpsellItems/${id}/${type}`,
      keepUnusedDataFor: 1,
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSubmitOrderMutation,
  useUpdateBasketMutation,
  useRemoveFromBasketMutation,
  useAddToBasketMutation,
  useAddVoucherMutation,
  useRemoveVoucherMutation,
  useAddBundleToBasketMutation,
  useRemoveBundleFromBasketMutation,
  useRemoveOutOfStockItemsFromBasketMutation,
  useUpdateBasketDeliveryMutation,
  useClearBasketMutation,
  useClearBasketDeliveryMutation,
  useQuickAddItemAndRewardMutation,
  useQuickSelectItemMutation,
  useQuickAddItemMutation,
  useQuickRemoveItemMutation,
  useCheckOutOfStockMutation,
  useSetRestaurantDistanceMutation,
  useSetBasketItemsMutation,
  useGetUpsellItemsQuery,
  useLazyGetUpsellItemsQuery
} = basketApi;